import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaAngleDown } from 'react-icons/fa';
import type { ParticipantsFilter } from '../../hooks/useParticipantsFilter';
import { ParticipantsExportMenuItem } from './ParticipantsExportMenuItem';

interface Props extends Omit<ChakraV3.ButtonProps, 'filter'> {
  filter: ParticipantsFilter;
}

export const ParticipantsActionMenu = (props: Props) => {
  const { filter, ...rest } = props;

  return (
    <ChakraV3.Menu.Root lazyMount={true} unmountOnExit={false}>
      <ChakraV3.Menu.Trigger asChild>
        <ChakraV3.Button variant='outline' {...rest}>
          Actions
          <FaAngleDown />
        </ChakraV3.Button>
      </ChakraV3.Menu.Trigger>
      <ChakraV3.Menu.Positioner>
        <ChakraV3.Menu.Content>
          <ParticipantsExportMenuItem filter={filter} />
        </ChakraV3.Menu.Content>
      </ChakraV3.Menu.Positioner>
    </ChakraV3.Menu.Root>
  );
};
